function addLineBreaksToYotpo() {
  const selector = '.yotpo-description';

  const formatElement = (element) => {
    // 1. Check if we have already formatted it to prevent duplicates
    if (element.classList.contains('js-breaks-added')) {
      return;
    }

    // 2. Get the current text
    const originalText = element.innerHTML;

    // 3. THE FIX: Replace asterisk groups with a line break + the asterisks.
    const newText = originalText.replace(/(\*+)/g, '<br><br>$1');

    // 4. Update the HTML
    element.innerHTML = newText;

    // 5. Mark element as done
    element.classList.add('js-breaks-added');
  };

  // Use MutationObserver to efficiently wait for the element to appear
  const observer = new MutationObserver((mutations, obs) => {
    const targetElement = document.querySelector(selector);
    if (targetElement) {
      formatElement(targetElement);
      obs.disconnect(); // Stop observing once the element is found and formatted
    }
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Also check if the element already exists, in case the script runs after it's loaded.
  const existingElement = document.querySelector(selector);
  if (existingElement) {
    formatElement(existingElement);
    observer.disconnect();
  }
}

// Run the function
addLineBreaksToYotpo();
